import React from "react";
import {HelpDirectory} from "../../../model";
import {ColumnDef} from "@tanstack/react-table";
import { DateCell} from "../../../component/list/cell";
import {EntityListTemplate} from "../../../component/template/EntityListTemplate";
import {HelpDirectoryRepository} from "../../../repository";

export const ListHelpDirectory = () => {

    const columns: ColumnDef<HelpDirectory>[] = [
        {
            header: "Nom",
            accessorKey: 'name',
            id: 'name',
        },
        {
            header: "Permission",
            accessorFn: (data: HelpDirectory) => data.permission ?? 'Accès libre',
            id: 'permission',
        },
        {
            header: 'Nombre de fichiers',
            accessorKey: 'numberOfFiles',
            id: 'numberOfFiles',
        },
        {
            header: `Dernière mise à jour`,
            accessorKey: `updatedAt`,
            id: `updatedAt`,
            cell: DateCell
        }
    ]

    return (
        <EntityListTemplate<HelpDirectory>
            repository={new HelpDirectoryRepository()}
            title={`Répertoire (Aide en ligne)`}
            columns={columns}
            rearrangeable
        />
    )
}